import dayjs from 'dayjs';

import { formatHccExpiry, parseSavedHccExpiry } from './savedReenrolment';
import { cardSideMissing } from './storedCardImages';

/**
 * One day, written the way the page writes an expiry ("D-M-YYYY").
 *
 * Dates, dayjs values, "30-11-2029", and "2029-11-30" (with or without a time) are the same
 * day. Anything else is not an expiry.
 */
export const hccExpiryKey = (value) => {
    if (value == null || value === '' || value === 'No') return '';

    if (typeof value === 'string') {
        const raw = value.trim();
        const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
        if (iso) return `${Number(iso[3])}-${Number(iso[2])}-${iso[1]}`;

        const fromPage = parseSavedHccExpiry(raw);
        return fromPage ? formatHccExpiry(fromPage) : '';
    }

    if (dayjs.isDayjs(value) && value.isValid()) return formatHccExpiry(value.toDate());

    const written = formatHccExpiry(value);
    return written === 'No' ? '' : written;
};

export const sameHccExpiry = (saved, current) => {
    const left = hccExpiryKey(saved);
    const right = hccExpiryKey(current);
    return Boolean(left) && left === right;
};

/**
 * Whether missing Health Care Card pictures should stop the parent.
 *
 * After a payment fails they return to a card the school already holds. The screen asked for
 * the pictures again and, once it believed they were uploaded, hid the boxes — nothing to
 * attach, and no way on.
 *
 * A card already sent, with that same expiry still on screen, is enough. A different expiry is
 * a new card and still has to be shown. A replacement they have started still needs both sides.
 */
export const hccUploadBlocksProgress = ({
    chosenFiles = [],
    storedSlots = [],
    savedExpiry = '',
    currentExpiry = null,
    previouslySent = false,
} = {}) => {
    const replacing = (chosenFiles || []).some(Boolean);
    if (!replacing && previouslySent && sameHccExpiry(savedExpiry, currentExpiry)) {
        return false;
    }

    return cardSideMissing(chosenFiles, storedSlots);
};
